import questionApis from '@/api/modules/question'
import { Loading } from 'element-ui'
// import { myLoad } from '@/components/myloading/index.js'
import Vue from 'vue'
// 定义Vue实例 调用全局显示和关闭loading方法
import questionApi from '@/api/modules/question'
const vm = new Vue()
export default {
  namespaced: true,
  // 定义初始数据
  state: {
    formData: [], // 问卷列表
    activeSubjectNumber: null, // 当前选中第几道题 index
    activeItem: null, // 当前选中题目的值
    activeSubjectType: null, // 当前选中题目的类型
    totalPage: null, // 当前总共有多少个分页
    questionTheme: null, // 问卷风格设置
    questionInfo: null, // 问卷内容
    prepareSubject: [], // 考前准备
    conclusionInfo: null, // 考试结束语
    contactUsSubject: null, // 联系我们
    settingData: null, // 问卷设置
    wxQuestionAuthList: null, // 授权知情书
    stockTypeList: [], // 个人题库
    // totalScore: 0  // 总分
  },
  getters: {
    gettersFormData: (state: any) => state.formData,
    activeSubjectNumber: (state: any) => state.activeSubjectNumber,
    activeItem: (state: any) => state.activeItem,
    activeSubjectType: (state: any) => state.activeSubjectType,
    totalPage: (state: any) => state.totalPage,
    questionTheme: (state: any) => state.questionTheme,
    questionInfo: (state: any) => state.questionInfo,
    prepareSubject: (state: any) => state.prepareSubject,
    contactUsSubject: (state: any) => state.contactUsSubject,
    conclusionInfo: (state: any) => state.conclusionInfo,
    settingData: (state: any) => state.settingData,
    wxQuestionAuthList: (state: any) => state.wxQuestionAuthList,
    stockTypeList: (state: any) => state.stockTypeList,
    // totalScore: (state: any) => state.totalScore,
  },
  // 同步的方法
  mutations: {
    // 向state 里面设置数据
    changeFromData(state: any, formData: any) {
      state.formData = formData
    },
    // 向state 里面设置数据
    changeSettingData(state: any, settingData: any) {
      state.settingData = settingData
    },
    // 向state 里面设置数据
    // changeTotalScore(state: any, totalScore: any) {

    //     state.totalScore = totalScore;
    // },
    changePrepareSubject(state: any, prepareSubject: any) {
      state.prepareSubject = prepareSubject
    },
    changeContactUsSubject(state: any, contactUsSubject: any) {
      state.contactUsSubject = contactUsSubject
    },
    changeActiveSubjectNumber(state: any, index: any) {
      state.activeSubjectNumber = index
    },
    changeActiveItem(state: any, activeItem: any) {
      state.activeItem = activeItem
    },
    changeActiveSubjectType(state: any, activeSubjectType: any) {
      state.activeSubjectType = activeSubjectType
    },
    changeTotalPage(state: any, totalPage: any) {
      state.totalPage = totalPage
    },
    changeQuestionTheme(state: any, questionTheme: any) {
      state.questionTheme = questionTheme
    },
    changeQuestionInfo(state: any, questionInfo: any) {
      state.questionInfo = questionInfo
    },
    changeConclusionInfo(state: any, conclusionInfo: any) {
      state.conclusionInfo = conclusionInfo
    },
    changeWxQuestionAuthList(state: any, wxQuestionAuthList: any) {
      state.wxQuestionAuthList = wxQuestionAuthList
    },
    changeStockTypeList(state: any, stockTypeList: any) {
      state.stockTypeList = stockTypeList
    },
  },
  // 异步的方法
  actions: {
    /**
     * @description: 保存搜索
     * @param {any} {commit}
     * @param {any} payload
     * @return {*} Promise
     */
    saveSearch({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        if (payload) {
          questionApi
            .saveSearch(payload)
            .then((res: any) => {
              resolve(res)
            })
            .catch((err: any) => {
              reject(err)
            })
        }
      })
    },
    // 在list.vue里面created生命周期里面触发
    getListAction({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        vm.$showLoading({
          background: 'rgba(255,255,255,.9)',
        })
        const now = Date.now()
        questionApis.getSubject(payload).then((res: any) => {
          // 重新获取序号
          let index = 0
          for (const list of res) {
            if (list.indexSort === 2) {
              index = 0
            }
            if (
              ![15, 16, 30, 31, 32, 35, 36].includes(list.subjectType) &&
              list.isStemIndex === 1
            ) {
              list.customIndexName = index
              index++
            }
          }
          commit('changeFromData', res)
          console.log('JS运行时间：', Date.now() - now)
          setTimeout(() => {
            console.log('总运行时间：', Date.now() - now)
          }, 0)

          vm.$hideLoading()
          resolve(res)
        })
      })
    },
    // 在list.vue里面created生命周期里面触发
    getPrepareSubjectAction({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        questionApis.getPrepareSubject(payload).then((res: any) => {
          commit('changePrepareSubject', res)
          resolve(res)
        })
      })
    },
    // 在list.vue里面created生命周期里面触发
    getSubjectByContactUs({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        questionApis.getSubjectByContactUs(payload).then((res: any) => {
          // console.log(res, '更新');
          commit('changeContactUsSubject', res)
          resolve(res)
        })
      })
    },

    setSettingData({ commit }: any, payload: any) {
      commit('changeSettingData', payload)
    },
    setFromData({ commit }: any, payload: any) {
      commit('changeFromData', payload)
    },
    setPrepareSubject({ commit }: any, payload: any) {
      commit('changePrepareSubject', payload)
    },
    setContactUsSubject({ commit }: any, payload: any) {
      commit('changeContactUsSubject', payload)
    },
    setActiveSubjectNumber({ commit }: any, payload: any) {
      commit('changeActiveSubjectNumber', payload)
    },
    setActiveItem({ commit }: any, payload: any) {
      commit('changeActiveItem', payload)
    },
    setActiveSubjectType({ commit }: any, payload: any) {
      commit('changeActiveSubjectType', payload)
    },
    setTotalPage({ commit }: any, payload: any) {
      commit('changeTotalPage', payload)
    },
    setQuestionTheme({ commit }: any, payload: any) {
      commit('changeQuestionTheme', payload)
    },
    setQuestionInfo({ commit }: any, payload: any) {
      commit('changeQuestionInfo', payload)
    },
    setConclusionInfo({ commit }: any, payload: any) {
      commit('changeConclusionInfo', payload)
    },
    setWxQuestionAuthList({ commit }: any, payload: any) {
      commit('changeWxQuestionAuthList', payload)
    },
    setStockTypeList({ commit }: any, payload: any) {
      console.log('更新列表')
      console.log(payload)
      commit('changeStockTypeList', payload)
    },
  },
}
